import { useEffect, useState } from 'react';

/**
 * @shared:low
 * Returns true when the viewport matches the given media query string.
 * SSR-safe: defaults to false on first render.
 */
export default function useMediaQuery(query) {
    const [matches, setMatches] = useState(false);

    useEffect(() => {
        const mql = window.matchMedia(query);
        setMatches(mql.matches);
        const handler = (e) => setMatches(e.matches);
        mql.addEventListener('change', handler);
        return () => mql.removeEventListener('change', handler);
    }, [query]);

    return matches;
}
